import React, { useState } from 'react';
import { HelpCircle, ChevronDown, ChevronUp } from 'lucide-react';
interface FAQ {
  id: string;
  question: string;
  answer: string;
}
const faqs: FAQ[] = [{
  id: 'start-class',
  question: 'I have just purchased... How do I start my class(es)?',
  answer: `If you have purchased a multiple class package (Choose your classes): 1. Click on Available Courses (to choose and enroll in your classes) 2. Click in box to choose each class following the guidelines for required and General courses 3. Click on the blue Enroll Me button 4. Click on My Courses and all your classes will be listed, ready to start

*If you have purchased a Preset 24 hour/8 class package: 1. Click on "My Courses". Your classes are listed and ready to start *If you have purchased any single class: 1. Click on "My Courses". Your class is there and rady to start *If previously purchased, log back into the system with your user name and password. you will be on the page My Courses (left side of page).  Click on My Courses and it will show you the class you have purchased and are now enrolled in. Click on that class and then click on review section to begin your class.`
}, {
  id: 'contract-law',
  question: 'Can I take two Contract Law classes to renew my license?',
  answer: `YES, within the 24 hours to renew or re certify, (30 hours for Brokers) you need 7 required courses, totaling 24 hours. Of that, Contract Law is one of them. Then, for the remaining hours, you can take any class, any type of credit, so long as you do not duplicate a class number within the same renewal period. That means you can take another Contract Law class with a different title and course number.`
}, {
  id: 'course-number',
  question: 'I need the course # before taking a class to be sure I am not duplicating the course.',
  answer: `According to ADRE, we are not allowed to publish or provide a course # until a student has actually attended the class. Each class for a school is given a Course #. No other school will have that unique course #. Therefore, for Desert Sage Seminars, all our classes have their own course # so as long as you do not repeat the class title during that renewal period, you will not be duplicating a course.`
}, {
  id: 'wrong-class',
  question: 'I chose and enrolled in the wrong class. What do I do?',
  answer: `Please contact Support at support@desertsageseminars.com so that they may add the class you prefer and delete the class you don't need at no charge!`
}, {
  id: 'cant-login',
  question: "I am already registered, but now can't seem to log in.",
  answer: `Be sure you are using the correct username and password. Your password is case sensitive. Look at your original registration email titled "Welcome to Desert Sage Seminars". That email contains your username.

Your browser may be saving an incorrect password. Try clearing the password box and re-type the correct password.

BEFORE resetting your password, add Administration@DesertSageSeminars.com to your Safe Senders list so that you can receive our emails.`
}, {
  id: 'no-email',
  question: 'I clicked on the Forgot Password button but did not receive the email. What do I do?',
  answer: `Please check your SPAM/JUNK MAIL folder. Sometimes automated filters mistakenly route legitimate emails there.

If you have not received it at all; have you changed your email address since your last log-in? Contact support at 602-377-6207 for assistance.`
}, {
  id: 'certificate',
  question: 'How do I get my certificate once I complete my class?',
  answer: `Upon class completion, you will see a Print Certificate button. Click on that and it will print your certificate. You can also go into Course History and see that there is a Print Certificate button next to each completed class. *You will need Adobe Acrobat reader to view and print your certificates.`
}, {
  id: 'nar-ethics',
  question: 'What do I do with my "Ethics & The Rules(with NAR Code of Ethics)" or "NAR Ethics Class" certificate to get the NAR Ethics credit?',
  answer: `Email a copy of your certificate to your local association and they will document the information to AAR and NAR for you. The current NAR triennial cycle is January 2025 - December 2027. You will get credit ONLY if you take an approved NAR Ethics course during this time period.`
}, {
  id: 'completed-24-hours',
  question: 'I have completed my 24 hours for CE. What do I do with my certificates?',
  answer: `ADRE would prefer that you add your classes online on their website. Go to the menu bar above and click on License Information for the link and for ADRE's directions`
}, {
  id: 'recommend',
  question: 'I really like your classes and would like to recommend you. What do I do?',
  answer: `Thank you!

We are pleased to know that you liked the classes. Please go to www.reteach.us.com and make a recommendation. You can also Google us and leave a review in the box. If you are on Face Book, we have our fan page www.Facebook.com/DesertSageSeminars`
}, {
  id: 'font-size',
  question: 'How do I change the font size of the text to be larger or smaller?',
  answer: `These are the two easy ways:

1. You can hold down the Control button (Ctrl) and click on the + or - sign

*On Safari it is the Command button (Cmd)

2. You can hold down the Control button (Ctrl) and scroll the mouse wheel to make larger or smaller font size`
}, {
  id: 'coupon-code',
  question: 'I have a coupon code for a free class. How do I use it?',
  answer: `Lucky You! First, be sure to register on the site as a New Student. Next, choose the class you want and click on the BUY NOW button. Upon checkout, you will see a box named Discount Coupon Code. Enter that code and click SUBMIT. The code should be accepted and your class will be placed into your account. Click on My Courses to get started.

*If you have a GRX code: Be sure there is no space between GRX and the number`
}, {
  id: 'adre-issues',
  question: 'Can you help me with ADRE issues?',
  answer: `We can certainly try! Call us at 602-377-6207 or email us at support@desertsageseminars.com

However, you may also want to check out ADRE's FAQs at this link:
http://www.azre.gov/Edu/StudentFaqs.aspx#FAQ1`
}, {
  id: 'broker-management',
  question: 'Please clarify who is supposed to take the new 9 hour Broker Management Clinic?',
  answer: `ADRE requires the following to complete the 9 hour BMC:

A renewing Designated Broker.

A renewing Delegated Associate Broker, that is, one who is delegated the authority to act on the Designated B's behalf pursuant to A.R.S §32-2151.01(G).

An original broker applicant, who must complete the BMC before the applicant's broker's license may be activated.

An associate broker within the 23 months prior to acting as a Delegated Associate Broker.

Any associate broker within the 23 months prior to being licensed as a Designated Broker.`
}, {
  id: 'class-expiration',
  question: 'How long do the classes I purchased (but did not take) stay in my account?',
  answer: `Great news! Our classes DO NOT EXPIRE. Once they are purchased and in your account, they remain there until you use them!`
}, {
  id: 'timer-issue',
  question: 'The timer on my class clicks down but then goes back up to start all over again. What can I do to fix this?',
  answer: `It is time to clear your cookies, browsing history and your cache. Most Web Gurus suggest doing this weekly if you use the internet a lot. Reboot your machine to complete the refresh.`
}, {
  id: 'ipad',
  question: 'Can I use my iPad to do your classes?',
  answer: `Absolutely! Please start by following the steps below to make this process smoother:

1. Close all Apps

2. Go to your Auto-lock and reset to Never (ONLY while you are actually doing the class so the device does not go to sleep. That will confuse and change the timer)

3. Go to Settings then to Safari and Clear your History and Cookies/Data

4. Log In and do your class`
}, {
  id: 'smartphone',
  question: 'Can I use my Smartphone to do my classes?',
  answer: `Yes, you can! However, we recommend clearing your browsing history first. Be sure to keep your phone from going to sleep so it does not disconnect from the server.

Per ADRE rules, you cannot use your smartphone to take Zoom classes.`
}, {
  id: 'clear-cookies',
  question: 'How do I clear my cookies/cache on my PC, iPad,  MAC or iPhone or Smartphone?',
  answer: `It is time to clear your cookies. Many Web Guys suggest you do this weekly.

Since every device is different and has different versions, we recommend searching on the internet for the correct directions.`
}, {
  id: 'phoenix-realtor',
  question: 'As a Phoenix REALTOR® member, how do I get my Free ONLINE CE Classes?',
  answer: `Register to create your account or Log In to your account at www.DesertSageSeminars.com

Click the BUY NOW button for the class or package you want

In your Shopping Cart, enter your MLS ID in the discount code box provided and click Apply Code button

Go to your My Classes folder and click the Title to begin your class`
}];
export function FAQs() {
  const [openId, setOpenId] = useState<string | null>(null);
  const toggleFAQ = (id: string) => {
    setOpenId(openId === id ? null : id);
  };
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-553">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-554">
        {/* Page Header */}
        <div className="mb-12" data-id="element-555">
          <div className="flex items-center justify-center mb-4" data-id="element-556">
            <HelpCircle className="w-12 h-12 text-brand-purple-600 mr-4" data-id="element-557" />
            <h1 className="text-4xl font-bold text-gray-900" data-id="element-558">
              Frequently Asked Questions
            </h1>
          </div>
          <p className="text-center text-lg text-gray-600" data-id="element-559">
            Find answers to common questions about Desert Sage Seminars
          </p>
        </div>

        {/* FAQ List */}
        <div className="space-y-4" data-id="element-560">
          {faqs.map(faq => <div key={faq.id} id={faq.id} className="bg-white border-2 border-gray-200 rounded-lg overflow-hidden hover:border-brand-purple-300 transition-colors" data-id="element-561">
              <button onClick={() => toggleFAQ(faq.id)} className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-562">
                <h3 className="text-lg font-semibold text-gray-900 pr-4" data-id="element-563">
                  {faq.question}
                </h3>
                {openId === faq.id ? <ChevronUp className="w-6 h-6 text-brand-purple-600 flex-shrink-0" data-id="element-564" /> : <ChevronDown className="w-6 h-6 text-gray-400 flex-shrink-0" data-id="element-565" />}
              </button>

              {openId === faq.id && <div className="px-6 pb-6 pt-2" data-id="element-566">
                  <div className="text-base text-gray-700 whitespace-pre-line leading-relaxed" data-id="element-567">
                    {faq.answer}
                  </div>
                  <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-568">
                    <button onClick={() => window.scrollTo({
                top: 0,
                behavior: 'smooth'
              })} className="text-brand-purple-600 hover:text-brand-purple-700 font-medium text-sm" data-id="element-569">
                      Back To Question List ↑
                    </button>
                  </div>
                </div>}
            </div>)}
        </div>

        {/* Contact Section */}
        <div className="mt-12 bg-brand-purple-50 rounded-lg p-8 border border-brand-purple-100" data-id="element-570">
          <h3 className="text-xl font-bold text-brand-purple-900 mb-3" data-id="element-571">
            Still Have Questions?
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-572">
            Can't find what you're looking for? Contact our support team and
            we'll be happy to help!
          </p>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-573">
            <a href="mailto:support@desertsageseminars.com" className="inline-flex items-center justify-center px-6 py-3 bg-brand-purple-600 text-white font-bold rounded-md hover:bg-brand-purple-700 transition-colors" data-id="element-574">
              Email Support
            </a>
            <a href="tel:602-377-6207" className="inline-flex items-center justify-center px-6 py-3 bg-white text-brand-purple-600 font-bold rounded-md border-2 border-brand-purple-600 hover:bg-brand-purple-50 transition-colors" data-id="element-575">
              Call 602-377-6207
            </a>
          </div>
        </div>
      </div>
    </div>;
}